const customerData = [
    {
        username: 'Alice B. Bevill',
        email: 'JamesMHenry@dayrep.com',
        phone: '732-533-0201',
        address: '2231 Webster Street Newark',
        balance: '$4,358',
        date: 'June 16, 2019'
    },
    {
        username: 'Betty M. Housley',
        email: 'BettyMHousley@armyspy.com',
        phone: '435-261-6681',
        address: '424 North Street Salt Lake City',
        balance: '$11,751',
        date: 'Jun 20, 2018'
    },
    {
        username: 'Betty M. Litwin',
        email: 'BettyMLitwin@rhyta.com',
        phone: '903-457-6202',
        address: '2317 Florence Street Greenville',
        balance: '$956',
        date: 'March 05, 2018'
    },
    {
        username: 'Chris T. Parks',
        email: 'ChrisTParks@rhyta.com',
        phone: '407-855-7376',
        address: '1521 McDonald Avenue Orlando',
        balance: '$6,541',
        date: 'March 20, 2019'
    },
    {
        username: 'Edward E. White',
        email: 'EdwardEWhite@armyspy.com',
        phone: '850-561-1648',
        address: '1246 Drainer Avenue Tallahassee',
        balance: '$1,854',
        date: 'June 22, 2019'
    },
    {
        username: 'Essie A. Nixon',
        email: 'EssieANixon@dayrep.com',
        phone: '269-639-7228',
        address: '2259 Goff Avenue South Haven',
        balance: '$4,456',
        date: 'June 22, 2018'
    },
    {
        username: 'Fabian M. Berryhill',
        email: 'FabianMBerryhill@teleworm.us',
        phone: '518-281-2680',
        address: 'North Greenbush, NY 12144',
        balance: '$2,510',
        date: 'June 20, 2019'
    },
    {
        username: 'Geneva J. Silverstein',
        email: 'GenevaJSilverstein@dayrep.com',
        phone: '507-406-9467',
        address: '3421 Pritchard Court Owatonna',
        balance: '$5,943',
        date: 'October 19, 2018'
    },
    {
        username: 'Herbert C. Patton',
        email: 'herbart@admiria.com',
        phone: '801-388-6508',
        address: '2470 Grove Street Bethpage',
        balance: '$5,412',
        date: 'July 20, 2019'
    },
    {
        username: 'James M. Henry',
        email: 'JamesMHenry@dayrep.com',
        phone: '951-314-6794',
        address: '3049 Denver Avenue City Of Commerce',
        balance: '$2,490',
        date: 'January 17, 2019 '
    },
    {
        username: 'John K. Sturdivant',
        email: 'JohnKSturdivant@rhyta.com',
        phone: '713-761-6484',
        address: '4494 Michael Street Sugar Land',
        balance: '$6,547',
        date: 'April 03, 2018'
    },
    {
        username: 'John T. Gonzalez',
        email: 'JohnTGonzalez@armyspy.com',
        phone: '610-594-6480',
        address: '1528 Jody Road Exton, PA',
        balance: '$1,121',
        date: 'June 16, 2018'
    },
    {
        username: 'Mario M. Sloan',
        email: 'MarioMSloan@rhyta.com',
        phone: '224-585-9508',
        address: '4733 Victoria Street Chicago',
        balance: '$9,650',
        date: 'June 15, 2019'
    },
    {
        username: 'Rodney V. Deshong',
        email: 'RodneyVDeshong@teleworm.us',
        phone: '678-737-9078',
        address: '4318 Kuhl Avenue Woodstock',
        balance: '$8,512',
        date: 'April 12, 2019'
    },
    {
        username: 'Ronald R. Maher',
        email: 'RonaldRMaher@armyspy.com',
        phone: '949-718-5315',
        address: '3894 Elk Street Newport Beach',
        balance: '$7,541',
        date: 'June 11, 2019'
    },
    {
        username: 'Ronnie A. Slayden',
        email: 'RonnieASlayden@teleworm.us',
        phone: '845-231-7995',
        address: '848 Camden Place Poughkeepsie',
        balance: '$2,269',
        date: 'June 02, 2018'
    },
];

export { customerData };
